import { HabitSchedule, TaskType } from '@griply/types';

export type ResolveTaskTypeForSchedulesOptions = {
  // Task-detail promotes a scheduled plain to-do straight to a habit when the
  // user may create habits; every other surface promotes it to repeating.
  preferHabit?: boolean;
};

export const resolveTaskTypeForSchedules = (
  currentType: TaskType,
  schedules: HabitSchedule[] | null | undefined,
  { preferHabit }: ResolveTaskTypeForSchedulesOptions = {},
): TaskType => {
  if (!schedules?.length) {
    return TaskType.Task;
  }
  if ([TaskType.Repeating, TaskType.Habit].includes(currentType)) {
    return currentType;
  }
  return preferHabit ? TaskType.Habit : TaskType.Repeating;
};
